'use client'

import * as React from 'react'
import { Editor } from '@tiptap/react'
import { ButtonHoverCard } from '@/tiptap/tiptap-ui/button-popover/button-hover-card'
import { ButtonFloatingEditor } from '@/tiptap/tiptap-ui/button-popover/button-floating-editor'

interface ButtonManagerProps {
  editor: Editor
}

export function ButtonManager({ editor }: ButtonManagerProps) {
  const [isEditing, setIsEditing] = React.useState(false)
  
  const handleEdit = React.useCallback(() => {
    setIsEditing(true)
  }, [])
  
  const handleClose = React.useCallback(() => {
    setIsEditing(false)
  }, [])
  
  // Listen for openButtonEditor event
  React.useEffect(() => {
    const handleOpenEditor = () => {
      setIsEditing(true)
    }
    
    editor.on('openButtonEditor', handleOpenEditor)
    
    return () => {
      editor.off('openButtonEditor', handleOpenEditor)
    }
  }, [editor])
  
  return (
    <>
      <ButtonHoverCard editor={editor} onEdit={handleEdit} />
      <ButtonFloatingEditor
        editor={editor}
        isOpen={isEditing}
        onClose={handleClose}
      />
    </>
  )
}